import { useCallback } from "react";
import { selectSlice } from "../internal/features/choice/model/selectors/selectSlice.js";
import { actions } from "../internal/features/choice/model/slice.js";
import { useAppDispatch } from "../internal/shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../internal/shared/lib/store/hooks/useAppSelector.js";
function useCreditChoice() {
  const dispatch = useAppDispatch();
  const choice = useAppSelector(selectSlice);
  const setCar = useCallback(
    (carState) => {
      dispatch(actions.setCar(carState));
    },
    [dispatch]
  );
  const setFinancialProgram = useCallback(
    (financialProgramState) => {
      dispatch(actions.setFinancialProgram(financialProgramState));
    },
    [dispatch]
  );
  const setCreditParameters = useCallback(
    (creditParametersState) => {
      dispatch(actions.setCreditParameters(creditParametersState));
    },
    [dispatch]
  );
  return {
    data: choice,
    actions: {
      setCar,
      setFinancialProgram,
      setCreditParameters
    }
  };
}
export {
  useCreditChoice
};
